/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Seniority_EntryInputs */

const en_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const de_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsteiger`)
};

const fr_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const es_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const it_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const nl_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const pl_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const fi_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloittelija`)
};

const da_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior`)
};

const sv_interview_qbank_seniority_entry = /** @type {(inputs: Interview_Qbank_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior`)
};

/**
* | output |
* | --- |
* | "Entry" |
*
* @param {Interview_Qbank_Seniority_EntryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_seniority_entry = /** @type {((inputs?: Interview_Qbank_Seniority_EntryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Seniority_EntryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_seniority_entry(inputs)
	if (locale === "fr") return fr_interview_qbank_seniority_entry(inputs)
	if (locale === "es") return es_interview_qbank_seniority_entry(inputs)
	if (locale === "it") return it_interview_qbank_seniority_entry(inputs)
	if (locale === "nl") return nl_interview_qbank_seniority_entry(inputs)
	if (locale === "pl") return pl_interview_qbank_seniority_entry(inputs)
	if (locale === "fi") return fi_interview_qbank_seniority_entry(inputs)
	if (locale === "da") return da_interview_qbank_seniority_entry(inputs)
	if (locale === "sv") return sv_interview_qbank_seniority_entry(inputs)
	return en_interview_qbank_seniority_entry(inputs)
});